/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicLinkRequestResponseDto
 */
export interface MagicLinkRequestResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof MagicLinkRequestResponseDto
     */
    accepted: boolean;
}

export function MagicLinkRequestResponseDtoFromJSON(json: any): MagicLinkRequestResponseDto {
    return MagicLinkRequestResponseDtoFromJSONTyped(json, false);
}

export function MagicLinkRequestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicLinkRequestResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accepted': json['accepted'],
    };
}

export function MagicLinkRequestResponseDtoToJSON(value?: MagicLinkRequestResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accepted': value.accepted,
    };
}

